'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '#pplx/frontend/aether/components/Link/index.js';
import { Popover } from '#pplx/frontend/aether/components/Popover/index.js';
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { talkToSalesCtaSelectedEvent, talkToSalesPopoverOpenedEvent, } from '#pplx/frontend/apps/ask/talk-to-sales/analytics.js';
import { useTalkToSalesCta } from '#pplx/frontend/apps/ask/talk-to-sales/useTalkToSalesCta.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
const GATED_ACTION_MESSAGES = defineMessages({
    orgCreateRoleTooltip: {
        defaultMessage: 'Custom roles are available to organizations on sales-assisted plans.',
        description: 'Popover CTA on the gated create-role action for self-serve orgs',
        id: 'd2b3cf1f85',
    },
});
/**
 * Renders a sales-assisted-gated action (a disabled button) whose hover
 * popover explains the gating and links to sales. A hover Popover is used
 * because aether Tooltip forbids interactive content; the span wrapper
 * receives hover since disabled buttons swallow pointer events. The popover
 * is a pointer-only affordance — surfaces with room for it should render
 * TalkToSalesEmptyState instead so keyboard and screen-reader users get a
 * real link. Self-gates: ineligible users see nothing, preserving each
 * surface's current behavior when the flag is off.
 */
export const TalkToSalesGatedAction = ({ surface, side = 'bottom', children, }) => {
    const cta = useTalkToSalesCta(surface);
    const { track } = useInstrumentation();
    if (!cta) {
        return null;
    }
    const handleOpenChange = (open) => {
        if (open) {
            track(talkToSalesPopoverOpenedEvent({
                name: 'enterprise talk to sales popover opened',
                data: { surface, audience: cta.audience, destination: cta.destination },
            }));
        }
    };
    return (_jsx(Popover, { interaction: "hover", side: side, matchTriggerWidth: false, onOpenChange: handleOpenChange, triggerElement: _jsx("span", { className: "inline-flex", children: children }), children: _jsxs("div", { className: "flex max-w-xs flex-col gap-2", children: [_jsx(TextPrimitive, { variant: "small", children: _jsx(FormattedMessage, { ...GATED_ACTION_MESSAGES[surface] }) }), _jsx(Link, { size: "tiny", variant: "secondary", fullWidth: true, href: cta.href, target: "_blank", rel: "noopener noreferrer", track: talkToSalesCtaSelectedEvent({
                        name: 'enterprise talk to sales cta selected',
                        data: { surface, audience: cta.audience, destination: cta.destination },
                    }), children: _jsx(FormattedMessage, { defaultMessage: "Contact sales", description: "Button in the gated-action popover that opens the sales contact flow", id: "d80a8f9ca1" }) })] }) }));
};
//# sourceMappingURL=TalkToSalesGatedAction.js.map